import * as React from 'react';

import { HeroModule, toLayoutValue } from '@coursera-web/cds-labs';

import type { ConsumerPathwayCareerAcademyPageDataContextType } from 'bundles/unified-career-academy/contexts/ConsumerPathwayCareerAcademyPageDataContext';

type HeroModuleProps = React.ComponentProps<typeof HeroModule>;
type HeroModuleSecondaryCta = HeroModuleProps['secondaryCta'];

type Props = {
  pageData: ConsumerPathwayCareerAcademyPageDataContextType;
};

export function HeroModuleRenderer({ pageData }: Props) {
  const { heroBanner } = pageData?.contentfulContent ?? {};

  const getHeroModuleProps = (): HeroModuleProps => {
    let cta: HeroModuleProps['cta'] = null;
    if (heroBanner?.ctaTarget && heroBanner?.ctaText) {
      cta = {
        target: heroBanner.ctaTarget,
        label: heroBanner.ctaText,
      };
    }

    let secondaryCta: HeroModuleSecondaryCta = null;
    if (heroBanner?.secondaryCtaTarget && heroBanner?.secondaryCtaText) {
      secondaryCta = {
        target: heroBanner.secondaryCtaTarget,
        label: heroBanner.secondaryCtaText,
        // Contentful -> Expected type conversion
        variant: heroBanner.secondaryCtaVariant as 'ghost' | 'secondary',
      };
    }

    let eyebrow: HeroModuleProps['eyebrow'];
    if (heroBanner?.eyebrow || heroBanner?.eyebrowImage) {
      eyebrow = {
        label: heroBanner?.eyebrow,
        image: heroBanner?.eyebrowImage,
        backgroundColor: heroBanner?.eyebrowBackground,
      };
    }

    return {
      ...heroBanner,
      cta,
      secondaryCta,
      eyebrow,
      layout: toLayoutValue(heroBanner?.layout),
    };
  };

  if (!heroBanner) return null;

  return <HeroModule {...getHeroModuleProps()} />;
}

export default HeroModuleRenderer;
